import { get } from 'lodash'
import { SCREEN_BREAKPOINT_DEVICES } from '@common/consts'

export const appDataSelector = state => get(state, 'app.data', {})

export const isMobileSelector = state => get(state, 'app.screenBreakPointIndex') >= SCREEN_BREAKPOINT_DEVICES.SCREEN_MOBILE

export const selectIsStudioSupportedDevice = (state) => !get(state, 'app.mobileDevice')
